import { schema } from 'normalizr'

const restaurantCourse = new schema.Entity('restaurantCourses')

export default restaurantCourse
